import { SurveyComponent } from "survey-vue3-ui";
import "survey-core/survey-core.min.css";
import "survey-core/i18n/spanish";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("SurveyComponent", SurveyComponent);
});
